import {CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CountrySelectorComponent} from "./selectcountry/countryselector/countryselector.component";
import {FilterCountryPipe} from "./selectcountry/countriespopup/filtercountry.pipe";
import {CountriesPopupComponent} from "./selectcountry/countriespopup/countriespopup.component";
import {CurrenciesPopupComponent} from "./currenciespopup/currenciespopup.component";
import {FilterCurrencyPipe} from "./currenciespopup/filtercurrency.pipe";
import {CryptosPopupComponent} from "./cryptopopup/cryptospopup.component";
import {FilterCryptoPipe} from "./cryptopopup/filtercrypto.pipe";
import {OrderSummaryComponent} from "./ordersummary/ordersummary.component";
import {WalletInfoComponent} from "./walletinfo/walletinfo.component";
import {SelectCryptoComponent} from "./selectcrypto/selectcrypto.component";
import {CountUpModule} from "ngx-countup";
import {SelectCrypto2Component} from "./selectcrypto2/selectcrypto2.component";
import {ExchangePriceComponent} from "./exchangeprice/exchangeprice.component";
import {StockRateComponent} from "./stockrate/stockrate.component";
import {CryptoSummaryBoxComponent} from "./cryptosummarybox/cryptosummarybox.component";
import {ChartComponent} from "./chart/chart.component";
import {RouterModule} from "@angular/router";
import {ContentBoxComponent} from "./contentbox/contentbox.component";
import {CommonModule} from "@angular/common";
import {DownloadWalletComponent} from "./downloadwallet/downloadwallet.component";
import {ShowMnemonicsComponent} from "./showmnemonics/showmnemonics.component";
import {AhoraCryptoCommonModule} from "@aparraga/ahoracrypto-client-common/src/app/common/ahoracrypto-common.module";
import {FilterNetworkPipe} from "./networkspopup/filternetwork.pipe";
import {NetworksPopupComponent} from "./networkspopup/networkspopup.component";
import {CardCarouselComponent} from "./card-carousel/card-carousel.component";
import { QRCodeComponent } from 'angularx-qrcode';
import {ClipboardModule} from "@angular/cdk/clipboard";
import {PaymentChooserComponent} from "./paymentchooser/paymentchooser.component";

@NgModule({
    declarations: [
      CountrySelectorComponent,
      CountriesPopupComponent,
      CurrenciesPopupComponent,
      NetworksPopupComponent,
      CryptosPopupComponent,
      OrderSummaryComponent,
      SelectCryptoComponent,
      SelectCrypto2Component,
      StockRateComponent,
      CardCarouselComponent,
      ContentBoxComponent,
      PaymentChooserComponent,
      WalletInfoComponent,
      ShowMnemonicsComponent,
      CryptoSummaryBoxComponent,
      ExchangePriceComponent,
      ChartComponent,
      FilterCryptoPipe,
      DownloadWalletComponent,
      FilterCountryPipe,
      FilterCurrencyPipe,
      FilterNetworkPipe
    ],
    imports: [
      FormsModule,
      RouterModule,
      CommonModule,
      CountUpModule,
      ClipboardModule,
      ReactiveFormsModule,
      AhoraCryptoCommonModule,
      QRCodeComponent
    ],
    exports: [
      CountrySelectorComponent,
      CountriesPopupComponent,
      CurrenciesPopupComponent,
      NetworksPopupComponent,
      SelectCryptoComponent,
      SelectCrypto2Component,
      CardCarouselComponent,
      WalletInfoComponent,
      PaymentChooserComponent,
      StockRateComponent,
      DownloadWalletComponent,
      ShowMnemonicsComponent,
      OrderSummaryComponent,
      ContentBoxComponent,
      CryptosPopupComponent,
      CryptoSummaryBoxComponent,
      ChartComponent,
      ExchangePriceComponent
    ],
    schemas: [
      CUSTOM_ELEMENTS_SCHEMA,
      NO_ERRORS_SCHEMA
    ],
})

export class PartsModule { }

